<div class="brand-settings-preview-wrapper">
  <h2>{{ "settings.customization.brand-settings.preview" | translate }}:</h2>
  <div class="brand-settings-preview-widget" #brandSettingsPreviewWidget>
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" class="brand-settings-preview-close-button">
      <g transform="translate(-5 -5)">
        <path d="M0,0H14V14H0Z" transform="translate(5 5)" fill="none"></path>
        <path d="M19,6.41,17.59,5,12,10.59,6.41,5,5,6.41,10.59,12,5,17.59,6.41,19,12,13.41,17.59,19,19,17.59,13.41,12Z" fill="currentColor"></path>
      </g>
    </svg>
    <div class="brand-settings-preview-content">
      <h2 class="brand-settings-preview-headline">
        @if (!isFormDesign) {
          You have bonus points
        }
        @if (isFormDesign) {
          Sign up here:
        }
      </h2>
      @if (!isFormDesign) {
        <div class="brand-settings-preview-text">Login to your account to access your bonus points.</div>
      }
      @if (isFormDesign) {
        <div class="brand-settings-preview-input-wrapper">
          <div class="brand-settings-preview-label">Email:</div>
          <div class="brand-settings-preview-input">
            <mat-icon class="tb-icon" svgIcon="tb:input-email"></mat-icon>
            my&#64;email.com
          </div>
        </div>
      }
      @if (isFormDesign) {
        <div class="brand-settings-preview-radio-button-wrapper">
          <div class="brand-settings-preview-label">Preferences:</div>
          <div class="brand-settings-preview-text">
            <i class="material-symbols-outlined radio-button-icon" [style.fontSize]="'18px'">radio_button_checked</i>
            <span>Telephone</span>
          </div>
          <div class="brand-settings-preview-text">
            <i class="material-symbols-outlined radio-button-icon" [style.fontSize]="'18px'">radio_button_unchecked</i>
            <span>Email</span>
          </div>
        </div>
      }

      @if (isFormDesign) {
        <div class="brand-settings-preview-input-wrapper country">
          <div class="brand-settings-preview-label">Your country:</div>
          <div class="brand-settings-preview-input">
            <img class="icon-flag" src="/assets/img/flags/sweden_1.png" alt="" />
            Sweden
          </div>
        </div>
      }

      <div class="brand-settings-preview-button-container">
        <div class="brand-settings-preview-button">
          @if (!isFormDesign) {
            <span>Login now</span>
          }
          @if (isFormDesign) {
            <span>Sign up now</span>
          }
        </div>
      </div>
      @if (isFormDesign) {
        <div class="brand-settings-preview-policy">
          By submitting to this form you agree to
          <span>our privacy policy</span>
        </div>
      }
    </div>
  </div>
</div>
